import { jsx, jsxs } from 'react/jsx-runtime';
import { useMemo, useState, useRef, useEffect } from 'react';
import cx from 'clsx';
import { InternalIconButton } from '@clover-web-lib-sprout/icon';
import injector_c35f11e4 from '@clover-util/inject-css';
import { createLocalization, getCurrentLocale } from '@clover-web-lib-sprout/common';
import { DateTime } from 'luxon';

const ArrowLeft = ({ ...props }) => (jsx("svg", { ...props, xmlns: "http://www.w3.org/2000/svg", role: props.role, focusable: false, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: jsx("path", { d: "M19.5 12H4.5M4.5 12L11.5 5M4.5 12L11.5 19", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }));
const ArrowRight = ({ ...props }) => (jsx("svg", { ...props, xmlns: "http://www.w3.org/2000/svg", role: props.role, focusable: false, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", children: jsx("path", { d: "M4.5 12H19.5M19.5 12L12.5 19M19.5 12L12.5 5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }));

var css$1 = "@media print{.CalendarNavStyles_module_header__6b1e02c870f6eba4{position:static}nav{display:none}}.CalendarNavStyles_module_visuallyHidden__6b1e02c870f6eba4{position:absolute;white-space:nowrap;width:1px;height:1px;overflow:hidden;border:0;padding:0;clip:rect(0 0 0 0);clip-path:inset(50%);margin:-1px}@font-face{font-family:\"Graphik\";font-weight:300;src:url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Light-Cy-Gr-Web.eot\");src:url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Light-Cy-Gr-Web.eot?#iefix\") format(\"embedded-opentype\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Light-Cy-Gr-Web.woff2\") format(\"woff2\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Light-Cy-Gr-Web.woff\") format(\"woff\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Light.otf\") format(\"opentype\")}@font-face{font-family:\"Graphik\";font-weight:400;src:url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Regular-Cy-Gr-Web.eot\");src:url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Regular-Cy-Gr-Web.eot?#iefix\") format(\"embedded-opentype\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Regular-Cy-Gr-Web.woff2\") format(\"woff2\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Regular-Cy-Gr-Web.woff\") format(\"woff\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Regular.otf\") format(\"opentype\")}@font-face{font-family:\"Graphik\";font-weight:500;src:url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Medium-Cy-Gr-Web.eot\");src:url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Medium-Cy-Gr-Web.eot?#iefix\") format(\"embedded-opentype\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Medium-Cy-Gr-Web.woff2\") format(\"woff2\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Medium-Cy-Gr-Web.woff\") format(\"woff\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Medium.otf\") format(\"opentype\")}@font-face{font-family:\"Graphik\";font-weight:600;src:url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Semibold-Cy-Gr-Web.eot\");src:url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Semibold-Cy-Gr-Web.eot?#iefix\") format(\"embedded-opentype\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Semibold-Cy-Gr-Web.woff2\") format(\"woff2\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Semibold-Cy-Gr-Web.woff\") format(\"woff\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Semibold.otf\") format(\"opentype\")}html{box-sizing:border-box;font-size:100%;--font-stack:\"Graphik\",\"Helvetica\",sans-serif}*,\n*::before,\n*::after{box-sizing:inherit}body{color:#000;font-feature-settings:normal;font-variant:normal;font-family:\"Graphik\",\"Helvetica\",sans-serif;font-family:var(--font-stack,\"Graphik\",\"Helvetica\",sans-serif);font-size:0.9375rem;line-height:1.6}body.dialogOpen{touch-action:none;overflow:hidden}@media only screen and (max-width: 900px){body.dialogOpen{position:fixed;width:100%}}.visuallyHidden{position:absolute;white-space:nowrap;width:1px;height:1px;overflow:hidden;border:0;padding:0;clip:rect(0 0 0 0);clip-path:inset(50%);margin:-1px}button:disabled,\nfieldset:disabled,\ninput:disabled,\noption:disabled,\noptgroup:disabled,\ntextarea:disabled{cursor:not-allowed}.CalendarNavStyles_module_calendarNav__6b1e02c870f6eba4{display:flex;flex-direction:row;justify-content:space-between;align-items:center;height:3rem;padding-top:1.5rem}.CalendarNavStyles_module_calendarNav__6b1e02c870f6eba4 .CalendarNavStyles_module_month__6b1e02c870f6eba4{display:flex;flex-direction:row;width:100%}.CalendarNavStyles_module_calendarNav__6b1e02c870f6eba4 .CalendarNavStyles_module_month__6b1e02c870f6eba4 .CalendarNavStyles_module_monthHeading__6b1e02c870f6eba4{font-size:1rem;line-height:calc(24 / 16);font-weight:500;text-transform:capitalize;margin-left:0;margin-right:0;display:flex;align-items:center;justify-content:center;width:100%}.CalendarNavStyles_module_calendarNav__6b1e02c870f6eba4 .CalendarNavStyles_module_month__6b1e02c870f6eba4 .CalendarNavStyles_module_monthHeading__6b1e02c870f6eba4.CalendarNavStyles_module_left__6b1e02c870f6eba4{margin-right:2.25rem}.CalendarNavStyles_module_calendarNav__6b1e02c870f6eba4 .CalendarNavStyles_module_month__6b1e02c870f6eba4 .CalendarNavStyles_module_monthHeading__6b1e02c870f6eba4.CalendarNavStyles_module_right__6b1e02c870f6eba4{margin-left:2.25rem}.CalendarNavStyles_module_calendarAction__6b1e02c870f6eba4{height:3rem}";
var modules_a112ffb0 = {"header":"CalendarNavStyles_module_header__6b1e02c870f6eba4","visuallyHidden":"CalendarNavStyles_module_visuallyHidden__6b1e02c870f6eba4","calendarNav":"CalendarNavStyles_module_calendarNav__6b1e02c870f6eba4","month":"CalendarNavStyles_module_month__6b1e02c870f6eba4","monthHeading":"CalendarNavStyles_module_monthHeading__6b1e02c870f6eba4","left":"CalendarNavStyles_module_left__6b1e02c870f6eba4","right":"CalendarNavStyles_module_right__6b1e02c870f6eba4","calendarAction":"CalendarNavStyles_module_calendarAction__6b1e02c870f6eba4"};
injector_c35f11e4(css$1,{"prepend":true,"attributes":{"data-package":"@clover-web-lib-sprout/calendar@0.6.1"}});

const CalendarNav = props => {
    const { nextMonthBtnAriaLabel, prevMonthBtnAriaLabel, primaryMonthHeading, secondaryMonthHeading, nextMonthBtnClick, prevMonthBtnClick, nextMonthBtnRef, prevMonthBtnRef, } = props;
    return (jsxs("div", { className: modules_a112ffb0.calendarNav, children: [jsxs("div", { className: modules_a112ffb0.month, children: [jsx(InternalIconButton, { ref: prevMonthBtnRef, IconSVG: ArrowLeft, accessibleName: prevMonthBtnAriaLabel, onClick: prevMonthBtnClick, className: modules_a112ffb0.calendarAction }), jsx("div", { className: cx(modules_a112ffb0.monthHeading, secondaryMonthHeading && modules_a112ffb0.left), children: jsx("span", { "aria-live": "polite", children: primaryMonthHeading }) }), !secondaryMonthHeading && (jsx(InternalIconButton, { onClick: nextMonthBtnClick, ref: nextMonthBtnRef, IconSVG: ArrowRight, accessibleName: nextMonthBtnAriaLabel, className: modules_a112ffb0.calendarAction }))] }), secondaryMonthHeading && (jsxs("div", { className: modules_a112ffb0.month, children: [jsx("div", { className: cx(modules_a112ffb0.monthHeading, secondaryMonthHeading && modules_a112ffb0.right), children: jsx("span", { "aria-live": "polite", children: secondaryMonthHeading }) }), jsx(InternalIconButton, { onClick: nextMonthBtnClick, ref: nextMonthBtnRef, IconSVG: ArrowRight, accessibleName: nextMonthBtnAriaLabel, className: modules_a112ffb0.calendarAction })] }))] }));
};
CalendarNav.displayName = 'CalendarNav';

const localizations = createLocalization();
const enDefault = {
    calendar: 'Calendar',
    calendarDialogLabel: 'Choose a date',
    ariaCommand: 'Edit date',
    dayList: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    monthList: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ],
    prevMonth: 'Previous Month',
    nextMonth: 'Next Month',
    clearSelection: 'Clear selection',
    saveCalendar: 'Save',
    cancelCalendar: 'Cancel',
    dateFormat: 'MM/dd/yyyy',
    dateFormatLabel: 'MM/DD/YYYY',
    dateMask: '99/99/9999',
    dateSelected: 'Selected {{date}}',
    errors: {
        emptyDate: 'Date cannot be empty',
        endDatePriorStartDate: 'Enter a date after the start date',
        invalidFormat: 'Enter a valid date format:',
        outOfRange: 'Enter a valid date',
    },
    selected: 'selected',
    selectedStartDate: 'Selected {{date}} as start date',
    selectedEndDate: 'Selected {{date}} as end date',
    startDateSelected: 'selected start date',
    endDateSelected: 'selected end date',
    rangeCleared: 'Date range cleared',
};
const deDefault = {
    calendar: 'Kalender',
    ariaCommand: 'Bearbeiten Datum',
    calendarDialogLabel: 'Wählen Sie ein Datum aus',
    dayList: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'], //MISSING DAYS IN WEB PORTAL CODE - NEED TRANSLATION TICKET
    monthList: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
    ],
    prevMonth: 'Vorherige Mondat',
    nextMonth: 'Nächster Mondat',
    clearSelection: 'Clear selection',
    saveCalendar: 'Fertig',
    cancelCalendar: 'Löschen',
    dateFormat: 'dd.MM.yyyy',
    dateFormatLabel: 'TT.MM.JJJJ',
    dateMask: '99.99.9999',
    dateSelected: '{{date}} ausgewählt',
    errors: {
        emptyDate: 'Datum darf nicht leer sein',
        endDatePriorStartDate: 'Ein Datum nach dem Startdatum eingeben',
        invalidFormat: 'Geben Sie ein gültiges Datumsformat ein:',
        outOfRange: 'Geben Sie ein gültiges Datum ein',
    },
    selected: 'ausgewählt',
    selectedStartDate: '{{date}} als Startdatum ausgewählt.',
    selectedEndDate: '{{date}} als Enddatum ausgewählt.',
    startDateSelected: 'Startdatum ausgewählt',
    endDateSelected: 'Enddatum ausgewählt',
    rangeCleared: 'Datumsbereich gelöscht',
};
const nlDefault = {
    calendar: 'Kalender',
    ariaCommand: 'Bewerken Datum',
    calendarDialogLabel: 'Kies een datum',
    dayList: ['Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'vrijdag', 'Zaterdag', 'Zondag'],
    monthList: [
        'Januari',
        'Februari',
        'Maart',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Augustus',
        'September',
        'Oktober',
        'November',
        'December',
    ],
    prevMonth: 'Vorige datam',
    nextMonth: 'Volgende datam',
    clearSelection: 'Clear selection',
    saveCalendar: 'Gedaan',
    cancelCalendar: 'Annuleren',
    dateFormat: 'd-M-yyyy',
    dateFormatLabel: 'D-M-JJJJ',
    dateMask: '9-9-9999',
    dateSelected: '{{date}} geselecteerd',
    errors: {
        emptyDate: 'De datum kan niet leeg zijn',
        endDatePriorStartDate: 'Voer een datum in die later is dan de startdatum',
        invalidFormat: 'Voer een geldige datumnotatie in:',
        outOfRange: 'Voer een geldige datum in',
    },
    selected: 'geselecteerd',
    selectedStartDate: '{{date}} geselecteerd als startdatum.',
    selectedEndDate: '{{date}} geselecteerd als einddatum.',
    startDateSelected: 'Startdatum geselecteerd',
    endDateSelected: 'Einddatum geselecteerd',
    rangeCleared: 'Datumbereik gewist',
};
// EN
localizations.addDefault(enDefault);
localizations.addLanguage('en-US', enDefault);
localizations.addLanguage('en-GB', Object.assign(enDefault, {
    dayList: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    dateFormat: 'dd/MM/yyyy',
    dateFormatLabel: 'DD/MM/YYYY',
    dateMask: '99/99/9999',
}));
localizations.addLanguage('en-CA', Object.assign(enDefault, {
    dayList: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
}));
localizations.addLanguage('en-IE', Object.assign(enDefault, {
    dayList: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
}));
// DE
localizations.addLanguage('de', deDefault);
localizations.addLanguage('de-AT', deDefault);
localizations.addLanguage('es-AR', {
    calendar: 'Calendario',
    ariaCommand: 'Editar la fecha',
    calendarDialogLabel: 'Elige una fecha',
    dayList: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
    monthList: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
    ],
    prevMonth: 'Mes anterior',
    nextMonth: 'Mes Siguiente',
    clearSelection: '',
    saveCalendar: 'Hecho',
    cancelCalendar: 'Cancelar',
    dateFormat: 'dd/MM/yyyy',
    dateFormatLabel: 'DD/MM/AAAA',
    dateMask: '99/99/9999',
    dateSelected: '{{date}} seleccionada',
    errors: {
        emptyDate: 'Es necesario ingresar una fecha',
        endDatePriorStartDate: 'Ingrese una fecha luego de la fecha de inicio',
        invalidFormat: 'Ingrese la fecha en formato válido:',
        outOfRange: 'Ingrese una fecha válida',
    },
    selected: 'seleccionada',
    selectedStartDate: 'Se seleccionó {{date}} como fecha de inicio.',
    selectedEndDate: 'Se seleccionó {{date}} como fecha de fin.',
    startDateSelected: 'Fecha de inicio seleccionada',
    endDateSelected: 'Fecha de fin seleccionada',
    rangeCleared: 'Rango de fechas eliminado',
});
localizations.addLanguage('fr-CA', {
    calendar: 'Calendrier',
    ariaCommand: 'Saisir votre date',
    calendarDialogLabel: 'Choisir une date',
    dayList: ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
    monthList: [
        'Janvier',
        'Février',
        'Mars',
        'Avril',
        'Mai',
        'Juin',
        'Juillet',
        'Août ',
        'Septembre',
        'Octobre',
        'Novembre',
        'Décembre',
    ],
    prevMonth: 'Mois précédent',
    nextMonth: 'Mois suivant',
    clearSelection: 'Supprimer la sélection',
    saveCalendar: 'Terminé',
    cancelCalendar: 'Annuler',
    dateFormat: 'yyyy-MM-dd',
    dateFormatLabel: 'AAAA-MM-JJ',
    dateMask: '9999-99-99',
    dateSelected: '{{date}} sélectionnée',
    errors: {
        emptyDate: 'Le champ Date ne peut pas être vide.',
        endDatePriorStartDate: 'Indiquer une date postérieure à la date de début.',
        invalidFormat: 'Saisissez un format de date valide:',
        outOfRange: 'Saisissez une date valide.',
    },
    selected: 'sélectionnée',
    selectedStartDate: 'Date de début sélectionnée : {{date}}.',
    selectedEndDate: 'Date de fin sélectionnée : {{date}}.',
    startDateSelected: 'Date de début sélectionnée',
    endDateSelected: 'Date de fin sélectionnée',
    rangeCleared: 'Période effacée',
});
// NL
localizations.addLanguage('nl', nlDefault);
localizations.addLanguage('nl-NL', nlDefault);
const getLanguageStrings = localizations.getLanguage;
const translateWithParams = localizations.translateWithParams;

/**
 * Determines the reportingDay from the current summaryHour and timestamp
 *
 * If the calendar date is the 5th and the time is prior to the users summaryHour, then the reporting day is the 4th
 *
 * @param summaryHour // Merchants summary hour, the default is 0
 * @param timestamp // The time to be converted to reporting day
 */
const getCurrentReportingDay = (summaryHour, timestamp) => {
    let currentReportingDay = DateTime.fromJSDate(timestamp);
    if (currentReportingDay.hour < summaryHour) {
        currentReportingDay = currentReportingDay.minus({ days: 1 });
    }
    return currentReportingDay.startOf('day').set({ hour: summaryHour }).toMillis();
};
/**
 * Creates an array of elements split into groups the length of size.
 * If array can't be split evenly, the final chunk will be the remaining elements.
 * Returns the new array of chunks.
 *
 * @param array // The array to process
 * @param size // The length of each chunk
 */
const chunk = (arr, size) => {
    const s = size === undefined ? 1 : Math.round(size);
    const l = arr === undefined ? 0 : arr.length;
    const result = [];
    let hold = [];
    if (l === 0 || s === 0) {
        return result;
    }
    for (let i = 0; i < l; i++) {
        hold.push(arr[i]);
        if (Number.isInteger((i + 1) / s) && (i + 1) / s !== 0) {
            // @ts-expect-error everything working as expected for calendar
            result.push(hold);
            hold = [];
        }
        else if (i + 1 === l) {
            // @ts-expect-error everything working as expected for calendar
            result.push(hold);
        }
    }
    return result;
};
/**
 * Determines the default boundaries for dates to generate. 1 year in the future and 1 year in the past.
 *
 */
const getDefaultBoundaries = () => {
    const now = DateTime.local();
    const startTimestamp = now.minus({ years: 1 }).toMillis();
    const endTimestamp = now.plus({ years: 1 }).toMillis();
    return {
        endTimestamp: endTimestamp,
        startTimestamp: startTimestamp,
    };
};
/**
 * Creates an array of DateTime Objects split into arrays of weeks
 * Returns an array of week arrays
 *
 * @param baseDate // The date that determines which month to generate.
 * @param language // The current locale. Used to generate the month in correct format and language.
 * @param offset // Number of the month to generate from baseDate. If baseDate is January and offet is 1, then February will be generated.
 */
const generateMonth = (baseDate, language, offset = 0) => {
    const targetDate = baseDate.plus({ months: offset });
    const daysInMonth = targetDate.daysInMonth;
    const startWeekday = language === 'en-GB' ? targetDate.startOf('month').weekday - 1 : targetDate.startOf('month').weekday;
    const endWeekday = targetDate.endOf('month').weekday;
    // Ensure daysInMonth is defined or fallback to a default value
    const daysInMonthChecked = daysInMonth || 30;
    // Prepare the month's data, including nulls for padding
    const monthArray = [
        ...Array.from({ length: startWeekday }, () => null), // Start padding
        ...Array.from({ length: daysInMonthChecked }, (_, i) => targetDate.set({ day: i + 1 })), // Actual days
        ...Array.from({ length: 6 - endWeekday }, () => null), // End padding
    ];
    // Use the chunk function to split monthArray into weeks
    const gridDays = chunk(monthArray, 7);
    return gridDays;
};
/**
 * Tests that a string is in the format of YYYY-MM-DDD
 * Returns boolean
 *
 * @param dateString // The string to test
 */
const isValidDateFormat = (dateString) => {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    return regex.test(dateString);
};

const noop = () => { };
const Calendar = props => {
    const { dateBoundaries, calendarId, date, enableFutureDates, disablePastDates, disableDates, disableRecurringDays, focusRef, focusOnRender = false, isCalendarOpen = false, summaryHour, testId, handleSelectDate = noop, onCalendarClose = noop, } = props;
    const currentLocale = getCurrentLocale();
    const text = useMemo(() => getLanguageStrings(currentLocale), [currentLocale]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [originalDate, setOriginalDate] = useState(null);
    const [monthDataArray, setMonthDataArray] = useState([]);
    const [focusInTable, setFocusInTable] = useState(focusOnRender);
    const nextMonthBtnRef = useRef(null);
    const prevMonthBtnRef = useRef(null);
    const internalFocusDateRef = useRef(null);
    const focusDateRef = focusRef || internalFocusDateRef;
    useEffect(() => {
        setSelectedDate(DateTime.fromISO(date, { locale: currentLocale }));
        setOriginalDate(DateTime.fromISO(date, { locale: currentLocale }));
    }, [date]);
    useEffect(() => {
        // Only want to fire this off if the selected date is different from the current month we are in
        (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.isValid) && setMonthDataArray([generateMonth(selectedDate, currentLocale, 0)]);
        if (!focusDateRef.current ||
            document.activeElement === focusDateRef.current ||
            document.activeElement === prevMonthBtnRef.current ||
            document.activeElement === nextMonthBtnRef.current)
            return;
    }, [selectedDate]);
    useEffect(() => {
        var _a;
        if (focusInTable)
            (_a = focusDateRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [monthDataArray, isCalendarOpen]);
    const handleTableKeyPress = (e) => {
        if (e.key !== 'Tab' && !e.shiftKey) {
            setFocusInTable(true);
            e.preventDefault();
            e.stopPropagation(); // Prevent event from bubbling up to other components
        }
        else {
            setFocusInTable(false);
            return;
        }
        switch (e.key) {
            case 'Enter': // Enter
                if (e.target instanceof HTMLElement) {
                    const ariaDisabled = e.target.getAttribute('aria-disabled');
                    if (ariaDisabled === 'true') {
                        return;
                    }
                }
                selectedDate && handleSelectDate(selectedDate.toFormat('yyyy-MM-dd'));
                return;
            case 'Escape': // Esc
                onCalendarClose();
                return;
            case ' ': // Space
                if (e.target instanceof HTMLElement) {
                    const ariaDisabled = e.target.getAttribute('aria-disabled');
                    if (ariaDisabled === 'true') {
                        return;
                    }
                }
                selectedDate && handleSelectDate(selectedDate.toFormat('yyyy-MM-dd'));
                return;
            case 'PageUp': // Page Up
                setPreviousMonth();
                return;
            case 'PageDown': // Page Down
                setNextMonth();
                return;
            case 'End': // End
                setMonthEnd();
                return;
            case 'Home': // Home
                setMonthStart();
                return;
            case 'ArrowLeft': // Left
                setPreviousDay();
                return;
            case 'ArrowUp': // Up
                setPreviousWeek();
                return;
            case 'ArrowRight': // Right
                setNextDay();
                return;
            case 'ArrowDown': // Down
                setNextWeek();
                return;
            default:
                return;
        }
    };
    const handleDateClick = (e, date) => {
        setSelectedDate(date);
        handleSelectDate(date.toFormat('yyyy-MM-dd'));
    };
    const setPreviousDay = () => {
        selectedDate && setSelectedDate(selectedDate.minus({ day: 1 }));
    };
    const setNextDay = () => {
        selectedDate && setSelectedDate(selectedDate.plus({ day: 1 }));
    };
    const setPreviousWeek = () => {
        selectedDate && setSelectedDate(selectedDate.minus({ week: 1 }));
    };
    const setNextWeek = () => {
        selectedDate && setSelectedDate(selectedDate.plus({ week: 1 }));
    };
    const setMonthStart = () => {
        selectedDate && setSelectedDate(selectedDate.startOf('month'));
    };
    const setMonthEnd = () => {
        selectedDate && setSelectedDate(selectedDate.endOf('month'));
    };
    const setPreviousMonth = (monthNavPressed = false) => {
        monthNavPressed && setFocusInTable(false);
        selectedDate && setSelectedDate(selectedDate.minus({ month: 1 }));
        selectedDate && setMonthDataArray([generateMonth(selectedDate, currentLocale, -1)]);
    };
    const setNextMonth = (monthNavPressed = false) => {
        monthNavPressed && setFocusInTable(false);
        selectedDate && setSelectedDate(selectedDate.plus({ month: 1 }));
        selectedDate && setMonthDataArray([generateMonth(selectedDate, currentLocale, 1)]);
    };
    return (jsxs("div", { id: calendarId, "data-testid": testId, children: [jsx(CalendarNav, { nextMonthBtnAriaLabel: text['nextMonth'], nextMonthBtnClick: () => setNextMonth(true), nextMonthBtnRef: nextMonthBtnRef, prevMonthBtnClick: () => setPreviousMonth(true), prevMonthBtnAriaLabel: text['prevMonth'], prevMonthBtnRef: prevMonthBtnRef, primaryMonthHeading: (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.isValid) ? selectedDate.toFormat('MMMM yyyy', { locale: currentLocale }) : undefined }), jsx(CalendarTable, { selectedDate: selectedDate, enableFutureDates: enableFutureDates, dateBoundaries: dateBoundaries, disableDates: disableDates, disableRecurringDays: disableRecurringDays, disablePastDates: disablePastDates, focusDateRef: focusDateRef, handleDateClick: handleDateClick, handleTableKeyPress: handleTableKeyPress, 
                //@ts-expect-error: the data passed is expected from the child component
                monthData: monthDataArray[0], summaryHour: summaryHour, originalDate: originalDate })] }));
};

var css = "@media print{.CalendarTableStyles_module_header__0a52d933a9b8618b{position:static}nav{display:none}}.CalendarTableStyles_module_visuallyHidden__0a52d933a9b8618b{position:absolute;white-space:nowrap;width:1px;height:1px;overflow:hidden;border:0;padding:0;clip:rect(0 0 0 0);clip-path:inset(50%);margin:-1px}@font-face{font-family:\"Graphik\";font-weight:300;src:url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Light-Cy-Gr-Web.eot\");src:url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Light-Cy-Gr-Web.eot?#iefix\") format(\"embedded-opentype\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Light-Cy-Gr-Web.woff2\") format(\"woff2\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Light-Cy-Gr-Web.woff\") format(\"woff\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Light.otf\") format(\"opentype\")}@font-face{font-family:\"Graphik\";font-weight:400;src:url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Regular-Cy-Gr-Web.eot\");src:url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Regular-Cy-Gr-Web.eot?#iefix\") format(\"embedded-opentype\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Regular-Cy-Gr-Web.woff2\") format(\"woff2\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Regular-Cy-Gr-Web.woff\") format(\"woff\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Regular.otf\") format(\"opentype\")}@font-face{font-family:\"Graphik\";font-weight:500;src:url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Medium-Cy-Gr-Web.eot\");src:url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Medium-Cy-Gr-Web.eot?#iefix\") format(\"embedded-opentype\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Medium-Cy-Gr-Web.woff2\") format(\"woff2\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Medium-Cy-Gr-Web.woff\") format(\"woff\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Medium.otf\") format(\"opentype\")}@font-face{font-family:\"Graphik\";font-weight:600;src:url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Semibold-Cy-Gr-Web.eot\");src:url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Semibold-Cy-Gr-Web.eot?#iefix\") format(\"embedded-opentype\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Semibold-Cy-Gr-Web.woff2\") format(\"woff2\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Semibold-Cy-Gr-Web.woff\") format(\"woff\"),url(\"https://cloverstatic.com/content/fonts/graphik/Graphik-Semibold.otf\") format(\"opentype\")}html{box-sizing:border-box;font-size:100%;--font-stack:\"Graphik\",\"Helvetica\",sans-serif}*,\n*::before,\n*::after{box-sizing:inherit}body{color:#000;font-feature-settings:normal;font-variant:normal;font-family:\"Graphik\",\"Helvetica\",sans-serif;font-family:var(--font-stack,\"Graphik\",\"Helvetica\",sans-serif);font-size:0.9375rem;line-height:1.6}body.dialogOpen{touch-action:none;overflow:hidden}@media only screen and (max-width: 900px){body.dialogOpen{position:fixed;width:100%}}.visuallyHidden{position:absolute;white-space:nowrap;width:1px;height:1px;overflow:hidden;border:0;padding:0;clip:rect(0 0 0 0);clip-path:inset(50%);margin:-1px}button:disabled,\nfieldset:disabled,\ninput:disabled,\noption:disabled,\noptgroup:disabled,\ntextarea:disabled{cursor:not-allowed}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b{--disabled-color:var(--neutral-colors-gray-disabled,#c7c7c7);--black-color:var(--neutral-colors-black,#000);--gray-color:var(--neutral-colors-gray,#727272);--selected-date-color:var(--primary-colors-green,#280);--calendar-white-color:var(--Neutral-white,#fff);border-collapse:separate;margin-top:0.9375rem;margin-bottom:0.9375rem;width:100%;height:18.75rem;color:#727272;color:var(--gray-color)}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b th{text-align:center;width:2.5rem;height:2.5rem}@media screen and (max-width: 699px){.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b th{padding-top:0.25rem}}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b td{width:2.5rem;text-align:center;padding:0 0.5px}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b td:first-child{padding-left:0}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b td:last-child{padding-right:0}@media screen and (max-width: 699px){.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b td{padding-top:0.25rem}}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b{cursor:pointer;width:2.5rem;height:2.5rem;border:1px solid transparent;padding:0;border-radius:4px;background-color:transparent}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b.CalendarTableStyles_module_offMonth__0a52d933a9b8618b{color:var(--disabled-color)}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b.CalendarTableStyles_module_currentDate__0a52d933a9b8618b span{border-bottom:1px solid;padding:0 0.125rem 0.125rem}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b.CalendarTableStyles_module_selected__0a52d933a9b8618b{border:1px solid var(--black-color)}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b.CalendarTableStyles_module_inRange__0a52d933a9b8618b{background:#f2fcee;background:var(--color-primary-colors-green-background,#f2fcee)}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b.CalendarTableStyles_module_originalDate__0a52d933a9b8618b, .CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b.CalendarTableStyles_module_rangeBoundary__0a52d933a9b8618b{color:var(--calendar-white-color);background-color:var(--selected-date-color)}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b.CalendarTableStyles_module_originalDate__0a52d933a9b8618b:focus, .CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b.CalendarTableStyles_module_rangeBoundary__0a52d933a9b8618b:focus{border-color:var(--black-color)}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b.CalendarTableStyles_module_originalDate__0a52d933a9b8618b[aria-disabled=true], .CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b.CalendarTableStyles_module_rangeBoundary__0a52d933a9b8618b[aria-disabled=true]{background:#f2fcee;background:var(--color-primary-colors-green-background,#f2fcee)}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b:hover{background:#f2fcee;background:var(--color-primary-colors-green-background,#f2fcee)}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b:hover.CalendarTableStyles_module_originalDate__0a52d933a9b8618b, .CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b:hover.CalendarTableStyles_module_rangeBoundary__0a52d933a9b8618b{background-color:#276a16;background-color:var(--selected-date-hover-color,#276a16)}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b:focus, .CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b:focus-visible{border-color:#000;border-color:var(--color-neutral-colors-black,#000);box-shadow:0 0 0 2px #43b02a;box-shadow:0 0 0 2px var(--color-primary-colors-green-accent,#43b02a);outline:2px solid transparent}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b:focus.CalendarTableStyles_module_selected__0a52d933a9b8618b, .CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b:focus-visible.CalendarTableStyles_module_selected__0a52d933a9b8618b{background-color:var(--calendar-white-color);border-color:var(--black-color)}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b:focus.CalendarTableStyles_module_selected__0a52d933a9b8618b.CalendarTableStyles_module_rangeBoundary__0a52d933a9b8618b, .CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b:focus-visible.CalendarTableStyles_module_selected__0a52d933a9b8618b.CalendarTableStyles_module_rangeBoundary__0a52d933a9b8618b{background:var(--selected-date-color)}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b:focus.CalendarTableStyles_module_selected__0a52d933a9b8618b:hover, .CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b:focus-visible.CalendarTableStyles_module_selected__0a52d933a9b8618b:hover{background-color:var(--selected-date-color);color:var(--calendar-white-color)}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b:focus.CalendarTableStyles_module_originalDate__0a52d933a9b8618b, .CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b:focus-visible.CalendarTableStyles_module_originalDate__0a52d933a9b8618b{background-color:var(--selected-date-color)}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b:focus.CalendarTableStyles_module_originalDate__0a52d933a9b8618b[aria-disabled=true], .CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b:focus-visible.CalendarTableStyles_module_originalDate__0a52d933a9b8618b[aria-disabled=true]{background:#f2fcee;background:var(--color-primary-colors-green-background,#f2fcee)}.CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b:disabled, .CalendarTableStyles_module_calendarTable__0a52d933a9b8618b .CalendarTableStyles_module_dateButton__0a52d933a9b8618b[aria-disabled=true]{pointer-events:none;color:var(--disabled-color)}";
var modules_9924a8c2 = {"header":"CalendarTableStyles_module_header__0a52d933a9b8618b","visuallyHidden":"CalendarTableStyles_module_visuallyHidden__0a52d933a9b8618b","calendarTable":"CalendarTableStyles_module_calendarTable__0a52d933a9b8618b","dateButton":"CalendarTableStyles_module_dateButton__0a52d933a9b8618b","offMonth":"CalendarTableStyles_module_offMonth__0a52d933a9b8618b","currentDate":"CalendarTableStyles_module_currentDate__0a52d933a9b8618b","selected":"CalendarTableStyles_module_selected__0a52d933a9b8618b","inRange":"CalendarTableStyles_module_inRange__0a52d933a9b8618b","originalDate":"CalendarTableStyles_module_originalDate__0a52d933a9b8618b","rangeBoundary":"CalendarTableStyles_module_rangeBoundary__0a52d933a9b8618b"};
injector_c35f11e4(css,{"prepend":true,"attributes":{"data-package":"@clover-web-lib-sprout/calendar@0.6.1"}});

const CalendarTable = props => {
    const { selectedDate, dateBoundaries, disableDates, disableRecurringDays, disablePastDates, enableFutureDates, focusDateRef, handleDateClick, handleTableKeyPress, monthData, originalDate, rangeValue, summaryHour, } = props;
    const currentLocale = getCurrentLocale();
    const text = useMemo(() => getLanguageStrings(currentLocale), [currentLocale]);
    const max = DateTime.now().endOf('day').plus({ hour: summaryHour });
    const today = DateTime.local().startOf('day');
    const isDayBlocked = (D) => {
        // Check if the current day is in the disableRecurringDays array
        if (disableRecurringDays === null || disableRecurringDays === void 0 ? void 0 : disableRecurringDays.includes(D.toFormat('ccc'))) {
            return true;
        }
        // Check if the current date is in the disabledDates array
        if (disableDates === null || disableDates === void 0 ? void 0 : disableDates.includes(D.toFormat('yyyy-MM-dd'))) {
            return true;
        }
        // disable dates
        const dayStart = D.startOf('day');
        const dayEnd = D.endOf('day');
        return ((dayStart >= max && !enableFutureDates) ||
            (dayEnd < max && disablePastDates) ||
            Boolean(dateBoundaries &&
                ((dateBoundaries.startTimestamp && dayStart < DateTime.fromMillis(dateBoundaries.startTimestamp)) ||
                    (dateBoundaries.endTimestamp && dayEnd > DateTime.fromMillis(dateBoundaries.endTimestamp)))));
    };
    const isToday = (D) => D.hasSame(today, 'day');
    const isInRange = (D) => {
        // Convert D to the start of its day for comparison
        const startOfDay = D.startOf('day');
        // Explicitly check if startDate and endDate are not undefined before comparing
        const isAfterStartDate = (rangeValue === null || rangeValue === void 0 ? void 0 : rangeValue.startDate) ? startOfDay >= rangeValue.startDate.startOf('day') : false;
        const isBeforeEndDate = (rangeValue === null || rangeValue === void 0 ? void 0 : rangeValue.endDate) ? startOfDay <= rangeValue.endDate.startOf('day') : false;
        // Return true if D is within the range, taking into account undefined start or end dates
        return isAfterStartDate && isBeforeEndDate;
    };
    const hasTabIndex = (D) => {
        var _a, _b;
        if (!(rangeValue === null || rangeValue === void 0 ? void 0 : rangeValue.startDate) && !(rangeValue === null || rangeValue === void 0 ? void 0 : rangeValue.endDate) && selectedDate !== null)
            return selectedDate.hasSame(D, 'day');
        return ((selectedDate &&
            ((_a = rangeValue === null || rangeValue === void 0 ? void 0 : rangeValue.startDate) === null || _a === void 0 ? void 0 : _a.hasSame(selectedDate, 'day')) &&
            ((_b = rangeValue === null || rangeValue === void 0 ? void 0 : rangeValue.startDate) === null || _b === void 0 ? void 0 : _b.hasSame(D, 'day'))) ||
            (selectedDate && selectedDate.hasSame(D, 'day')));
    };
    return (jsxs("table", { className: modules_9924a8c2.calendarTable, role: "grid", onKeyDown: handleTableKeyPress, children: [jsx("thead", { children: jsx("tr", { children: text['dayList'].map(dw => (jsx("th", { scope: "col", "aria-label": dw, abbr: dw, children: dw.charAt(0) }, dw))) }) }), jsx("tbody", { children: monthData === null || monthData === void 0 ? void 0 : monthData.map((week, i) => (jsx("tr", { children: week === null || week === void 0 ? void 0 : week.map((d, j) => {
                        var _a, _b;
                        if (!d)
                            return (jsx("td", { className: modules_9924a8c2.offMonth, children: "\u00A0" }, `day-cell-${j}`));
                        const D = d.startOf('day');
                        const isBlocked = isDayBlocked(D);
                        const isSameStartDay = (_a = rangeValue === null || rangeValue === void 0 ? void 0 : rangeValue.startDate) === null || _a === void 0 ? void 0 : _a.hasSame(D, 'day');
                        const isSameEndDay = (_b = rangeValue === null || rangeValue === void 0 ? void 0 : rangeValue.endDate) === null || _b === void 0 ? void 0 : _b.hasSame(D, 'day');
                        const isSelectedDate = selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.hasSame(D, 'day');
                        const isCurrentDate = isToday(D);
                        const isDateInRange = isInRange(D);
                        const dateAriaSuffix = isSameStartDay && isSameEndDay
                            ? ` ${text.selected}`
                            : isSameStartDay
                                ? ` ${text.startDateSelected}`
                                : isSameEndDay
                                    ? ` ${text.endDateSelected}`
                                    : '';
                        const dayAriaText = `${D.toFormat('DDDD', { locale: currentLocale })}${dateAriaSuffix}`;
                        const dateButtonClasses = cx(modules_9924a8c2.dateButton, {
                            [modules_9924a8c2.rangeBoundary]: !isBlocked && (isSameStartDay || isSameEndDay),
                            [modules_9924a8c2.originalDate]: !rangeValue && originalDate && originalDate.hasSame(D, 'day') && modules_9924a8c2.originalDate,
                            [modules_9924a8c2.selected]: !isBlocked && isSelectedDate,
                            [modules_9924a8c2.currentDate]: isCurrentDate,
                            [modules_9924a8c2.inRange]: isDateInRange,
                        });
                        return (jsx("td", { children: jsx("button", { type: "button", "aria-label": dayAriaText + ((originalDate === null || originalDate === void 0 ? void 0 : originalDate.hasSame(D, 'day')) ? ' selected' : ''), className: dateButtonClasses, tabIndex: hasTabIndex(D) ? 0 : -1, ref: isSelectedDate ? focusDateRef : null, "aria-disabled": isBlocked, onClick: e => !isBlocked && handleDateClick(e, D), onKeyDown: e => {
                                    if (!isBlocked && ['Enter', 'Space', ' '].includes(e.key)) {
                                        e.preventDefault();
                                        handleDateClick(e, D);
                                    }
                                }, children: jsx("span", { children: D.get('day') }) }) }, `day-cell-${j}`));
                    }) }, `week-${i}`))) })] }));
};
CalendarTable.displayName = 'CalendarTable';

export { Calendar, CalendarNav, CalendarTable, chunk, generateMonth, getCurrentReportingDay, getDefaultBoundaries, getLanguageStrings, isValidDateFormat, translateWithParams };
//# sourceMappingURL=index.mjs.map
